import { exclusionErknmAdditionalFields } from '../constants/exclusionErknmAdditionalFields';
import { exclusionErpAdditionalFields } from '../constants/exclusionErpAdditionalFields';
import { initialKnmListAdditionalFields, isTestAdditionalField } from '../constants/initialKnmListAdditionalFields';
import { IKnmListFilter } from '../interfaces/IKnmListFilter';
import { IKnmListFilterExtraField } from '../interfaces/IKnmListFilterExtraField';

export function mapFilterAdditionalFields(isErknm: boolean, isUserTest: boolean) {
  return (filter: IKnmListFilter): IKnmListFilterExtraField[] => {
    let items = initialKnmListAdditionalFields;

    if (isUserTest && !initialKnmListAdditionalFields.find(i => i.id === isTestAdditionalField.id)) {
      items = [...initialKnmListAdditionalFields, isTestAdditionalField];
    }

    return items
      .filter(item =>
        isErknm ? !exclusionErknmAdditionalFields.includes(item.id) : !exclusionErpAdditionalFields.includes(item.id),
      )
      .map<IKnmListFilterExtraField>(field => {
        switch (field.id) {
          case 'address': {
            return {
              ...field,
              isSelected: Boolean(filter.address),
            };
          }
          case 'disapprove': {
            return {
              ...field,
              isSelected: Boolean(filter.disapprove?.value),
            };
          }
          case 'supervisionType': {
            return {
              ...field,
              isSelected: Boolean(filter.supervisionType?.value),
            };
          }
          case 'hasViolations': {
            return {
              ...field,
              isSelected: Boolean(filter.hasViolations?.value),
            };
          }
          case 'dataNotEqualEGRUL': {
            return {
              ...field,
              isSelected: Boolean(filter.dataNotEqualEGRUL?.value),
            };
          }
          case 'startDate': {
            return {
              ...field,
              isSelected: Boolean(filter.startDate),
            };
          }
          case 'startDateBetween': {
            return {
              ...field,
              isSelected:
                (filter.startDateBetweenStart && filter.startDateBetweenStart.length > 0) ||
                (filter.startDateBetweenEnd && filter.startDateBetweenEnd.length > 0) ||
                false,
            };
          }
          case 'approveDocRequestDate': {
            return {
              ...field,
              isSelected: Boolean(filter.approveDocRequestDate),
            };
          }
          case 'approveDocOrderDate': {
            return {
              ...field,
              isSelected: Boolean(filter.approveDocOrderDate),
            };
          }
          case 'chlistFillingIndicationType': {
            return {
              ...field,
              isSelected: Boolean(filter.chlistFillingIndicationType?.value),
            };
          }
          case 'subjectInn': {
            return {
              ...field,
              isSelected: Boolean(filter.subjectInn),
            };
          }
          case 'knmAnnulled': {
            return {
              ...field,
              isSelected: Boolean(filter.knmAnnulled),
            };
          }
          case 'createdByMe': {
            return {
              ...field,
              isSelected: Boolean(filter.createdByMe),
            };
          }
          case 'subjectOrgName': {
            return {
              ...field,
              isSelected: Boolean(filter.subjectOrgName),
            };
          }
          case 'regType': {
            return {
              ...field,
              isSelected: Boolean(filter.regType),
            };
          }
          case 'mspCategory': {
            return {
              ...field,
              isSelected: Boolean(filter.mspCategory),
            };
          }
          case 'planNum': {
            return {
              ...field,
              isSelected: Boolean(filter.planNum),
            };
          }
          case 'approveDocRequestNum': {
            return {
              ...field,
              isSelected: Boolean(filter.approveDocRequestNum),
            };
          }
          case 'approveDocOrderNum': {
            return {
              ...field,
              isSelected: Boolean(filter.approveDocOrderNum),
            };
          }
          case 'objectOgrn': {
            return {
              ...field,
              isSelected: Boolean(filter.objectOgrn),
            };
          }
          case 'prosecutorOrganizations': {
            return {
              ...field,
              isSelected: Boolean(filter.prosecutorOrganizations?.length),
            };
          }
          case 'dataSetNotInTime': {
            return {
              ...field,
              isSelected: Boolean(filter.dataSetNotInTime),
            };
          }
          case 'deletedOnly': {
            return {
              ...field,
              isSelected: Boolean(filter.deletedOnly),
            };
          }
          case 'deletedInclude': {
            return {
              ...field,
              isSelected: Boolean(filter.deletedInclude),
            };
          }
          case 'legalBasisDocName': {
            return {
              ...field,
              isSelected: Boolean(filter.legalBasisDocName),
            };
          }
          case 'orderDone': {
            return {
              ...field,
              isSelected: Boolean(filter.orderDone),
            };
          }
          case 'recEmptyOrLate': {
            return {
              ...field,
              isSelected: Boolean(filter.recEmptyOrLate),
            };
          }
          case 'regLate': {
            return {
              ...field,
              isSelected: Boolean(filter.regLate),
            };
          }
          case 'resultEmpty': {
            return {
              ...field,
              isSelected: Boolean(filter.resultEmpty),
            };
          }
          case 'resultEmptyOrLate': {
            return {
              ...field,
              isSelected: Boolean(filter.resultEmptyOrLate),
            };
          }
          case 'appealed': {
            return {
              ...field,
              isSelected: Boolean(filter.appealed),
            };
          }
          case 'noPunishment': {
            return {
              ...field,
              isSelected: Boolean(filter.noPunishment),
            };
          }
          case 'approved': {
            return {
              ...field,
              isSelected: Boolean(filter.approved),
            };
          }
          case 'statuses': {
            return {
              ...field,
              isSelected: Boolean(filter.statuses?.length),
            };
          }
          case 'signed': {
            return {
              ...field,
              isSelected: Boolean(filter.signed),
            };
          }
          case 'pubStatuses': {
            return {
              ...field,
              isSelected: Boolean(filter.pubStatuses?.length),
            };
          }
          case 'subjectTypes': {
            return {
              ...field,
              isSelected: Boolean(filter.subjectTypes?.length),
            };
          }
          case 'notifyLate': {
            return {
              ...field,
              isSelected: Boolean(filter.notifyLate),
            };
          }
          case 'admLevel': {
            return {
              ...field,
              isSelected: Boolean(filter.admLevel),
            };
          }
          case 'erpId': {
            return {
              ...field,
              isSelected: Boolean(filter.erpId),
            };
          }
          case 'inspectorFullName': {
            return {
              ...field,
              isSelected: Boolean(filter.inspectorFullName),
            };
          }
          case 'createPlanDate': {
            return {
              ...field,
              isSelected: Boolean(filter.createPlanDate),
            };
          }
          case 'updatePlanDate': {
            return {
              ...field,
              isSelected: Boolean(filter.updatePlanDate),
            };
          }
          case 'approveRequiredType': {
            return {
              ...field,
              isSelected: Boolean(filter.approveRequiredType),
            };
          }
          case 'approvedRequired': {
            return {
              ...field,
              isSelected: Boolean(filter.approvedRequired),
            };
          }
          case 'requirementDetails': {
            return {
              ...field,
              isSelected: Boolean(filter.requirementDetails),
            };
          }
          case 'assignmentNumber': {
            return {
              ...field,
              isSelected: Boolean(filter.assignmentNumber),
            };
          }
          case 'assignmentDate': {
            return {
              ...field,
              isSelected: Boolean(filter.assignmentDate),
            };
          }
          case 'isTest': {
            return {
              ...field,
              isSelected: Boolean(filter.isTest),
            };
          }
          case 'assignmentDateBetween': {
            return {
              ...field,
              isSelected:
                (filter.assignmentDateBetweenStart && filter.assignmentDateBetweenStart.length > 0) ||
                (filter.assignmentDateBetweenEnd && filter.assignmentDateBetweenEnd.length > 0) ||
                false,
            };
          }
          case 'responsibilityTypeCodes': {
            return {
              ...field,
              isSelected: Boolean(filter.responsibilityTypeCodes?.length),
            };
          }
          case 'amountOfPunishmentBetween': {
            return {
              ...field,
              isSelected:
                (filter.amountOfPunishmentFrom && filter.amountOfPunishmentFrom.length > 0) ||
                (filter.amountOfPunishmentTo && filter.amountOfPunishmentTo.length > 0) ||
                false,
            };
          }
          default:
            return field;
        }
      });
  };
}
